<template>
    <div class="page-header">
      <page-info/>
        <div class="container">
            <div class="page-header__inner">
              <breadcrumbs :items="subHeader.breadcrumbs"/>
                <div class="row page-header__row v-center">
                    <div class="col  sm-12 page-header__col page-header__col-left" :class="subHeader.btn.title?'d8':'d12'">
                        <div class="page-header__col-inner page-header__content">
                            <div class="pageTitle" :style="'color:'+params.settings.titleColor" :class="'position--'+params.settings.titlePosition">
                            <vue-writer
                                :array='[subHeader.title]'
                                :iterations="1"
                                :typeSpeed="70"
                                v-if="params.settings.useTitleAnimation"
                            >
                                <h1 class="page-header__title" v-html="subHeader.title" style="display: none"></h1>
                            </vue-writer>
                            <h1 class="page-header__title" v-html="subHeader.title" v-else-if="subHeader.dontShowSubHeader != true"></h1>
                            </div>
                            <div class="page-header__desc flex v-center">
                                <div class="page-header__desc-text mb-5" v-if="(pageSettings.pageInfo.custom_subheader || subHeader.desc) && (subHeader.dontShowSubHeader != true)">{{ pageSettings.pageInfo.custom_subheader ?pageSettings.pageInfo.custom_subheader :subHeader.desc }}</div>
                                <div class="page-header__desc-media" v-if="params.video">
                                    <svg class="icon" width="16" height="16" viewBox="0 0 16 16"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8 0C3.58178 0 0 3.58172 0 8C0 12.4183 3.58178 16 8 16C12.4182 16 16 12.4183 16 8C16 3.58172 12.4182 0 8 0ZM10.765 8.42406L6.765 10.9241C6.68406 10.9746 6.59203 11 6.5 11C6.41663 11 6.33313 10.9792 6.25756 10.9373C6.09863 10.8491 6 10.6819 6 10.5V5.5C6 5.31812 6.09863 5.15088 6.25756 5.06275C6.4165 4.97412 6.61084 4.9795 6.765 5.07594L10.765 7.57594C10.9111 7.6675 11 7.82766 11 8C11 8.17234 10.9111 8.33253 10.765 8.42406Z"/>
                                    </svg>
                                    <span>{{ params.video.title }}</span>
                                </div>
                            </div>
                            <div class="page-header__tags gap-10" v-if="subHeader.tags">
                                <a-badge v-for="(tag, i) in subHeader.tags" :key="i" :params="tag">{{ tag.name }}</a-badge>
                            </div>
                        </div>
                    </div>
                    <div class="col d4 sm-12 page-header__col page-header__col-right" v-if="subHeader.btn.title&&subHeader.btn.title.trim()!=''">
                        <div class="page-header__col-inner">
                            <ABtn :label="subHeader.btn.title"
                                  :class="params.hero ? 'light' : 'secondary'"
                                  :href="subHeader.btn.link ? subHeader.btn.link : false"
                                  :fill="params.hero ? 'outlined' : ''"
                                  v-if="subHeader.btn.title"
                            />
                        </div>
                    </div>
                </div>
                <div class="page-header__v-text" v-if="subHeader.vertical_text">
                    <template v-for="(word, i) in subHeader.vertical_text.split(' ')">
                        <div class="page-header__v-text-item">{{ word }}</div>
                        <div class="page-header__v-text-line"></div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueWriter from 'vue-writer'
import {useHeader} from "../composables/useHeader";
import { ABtn, ABadge } from './ui'
import Breadcrumbs from './main/Breadcrumbs.vue'
import PageInfo from "./main/PageInfo.vue";
import {usePageSettings} from "../composables/usePageSettings";

export default {
    components: {
      PageInfo,
        ABtn,
        ABadge,
        Breadcrumbs,
        VueWriter,
    },
    name: 'PageHeader',
    props: ['params'],
    setup: (props, ctx) => {
      const {subHeader,showSchemaOrg} = useHeader();
      const {pageSettings} = usePageSettings();
      showSchemaOrg();
      return {
        subHeader,
        pageSettings
      }
    },
}
</script>

<style lang="scss">
    .page-header {
        padding-top: calc(rem(100) + rem(50));
        padding-bottom: rem(60);
        background-color: #fff;
        height: 100%;
        > .container {
            height: 100%;
        }
        @include tablet {
          padding-top: calc(rem(80) + rem(38));
        }
        @include mobile {
          padding-top: calc(rem(55) + rem(26));
            padding-bottom: rem(16);
        }
        &__inner {
            position: relative;
            height: 100%;

            .#{$pageTypeSecondary} & {
                @include tablet {
                    display: none;
                }
            }
        }
        &__row {
            height: 100%;
        }
        &__title {
            @include mobile {
                margin: rem(10) 0 0 0;
            }
        }
        &__desc {
            font-size: rem(16);
            line-height: rem(26);
            @include tablet {
                font-size: rem(14);
                line-height: rem(20);
                flex-direction: column;
                align-items: stretch;
            }
            &-text {
                margin-right: rem(10);
                @include mobile {
                    display: none;
                }
            }
            &-media {
                display: inline-flex;
                align-items: center;
                cursor: pointer;
                font-weight: 600;

                @include tablet {
                    margin-top: rem(10);
                }

                .icon {
                    margin-right: rem(6);
                    fill: currentColor;
                }
            }
        }

        &__tags {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;
        }
        &__col {
            &-inner {
                width: 100%;
                //max-width: calc(100% - rem(500));

                @include tablet {
                    //max-width: calc(100% - rem(250));
                }

                @include mobile {
                    max-width: unset;
                }
            }
            &-right {
                > div {
                    display: flex;
                    justify-content: flex-end;


                  .#{$pageTypeSecondary} & {
                    justify-content: flex-start;
                  }
                }

                @include mobile {
                    padding-top: rem(40);
                }

                .a-btn {
                    min-width: rem(230);
                    @include mobile {
                        width: 100%;
                    }
                }
            }
        }

        &__v-text {
            position: absolute;
            right: rem(-175);
            top: rem(95);
            transform: rotate(-90deg);
            height: auto;
            width: rem(260);
            display: flex;
            justify-content: space-between;
            align-items: center;
            text-transform: uppercase;
            font-size: rem(14);
            color: #A4AADA;
            z-index: 10;

        @include desktopSm {
            display: none;
        }

        &-line {
            width: 100%;
            height: 1px;
            background: #A4AADA;
            margin: 0 1rem;

            &:last-child {
                display: none;
            }
        }
    }
}
</style>